module.exports = __webpack_public_path__ + "images/choices/qrcode-wusong-76d72687f8aaf5c2a04a1bfaa8ee5402.jpg";